import { useCallback } from 'react'

import { getWalletClient } from '@wagmi/core'
import { useAccount, useChainId } from 'wagmi'

import { GasParams, Hash } from 'types/entities'

import { useSettingRpcUrl } from 'state/user/hooks'

import { logger } from 'utils/logger'
import { errors } from 'constants/errors'
import { etherNumbers } from 'constants/variables'
import { parseErrorToUserReadableMessage } from 'utils/errors'

export type CreateWalletTransactionParams = {
  to: Hash
  gas?: bigint
  amount?: bigint
  calldata?: Hash
  gasParams?: GasParams
}

export function useCreateTransaction() {
  const chainId = useChainId()
  const rpcUrl = useSettingRpcUrl()
  const { address, isConnected } = useAccount()

  return useCallback(
    async ({
      to,
      gas,
      calldata,
      gasParams,
      amount = etherNumbers.BG_ZERO,
    }: CreateWalletTransactionParams): Promise<Hash> => {
      try {
        const walletClient = await getWalletClient({ chainId })
        if (!walletClient) {
          throw new Error(errors.wallet.WALLET_REQUIRED)
        }

        const txHash = await walletClient.sendTransaction({
          to,
          gas,
          data: calldata,
          value: amount,
          account: address,
          ...gasParams,
        })

        return txHash
      } catch (err) {
        const err_message = `CREATE TX ${err.message}`
        logger.error('useCreateTransaction', err_message)
        throw new Error(parseErrorToUserReadableMessage(err))
      }
    },
    [address, chainId, rpcUrl, isConnected],
  )
}
